import { render } from "./management.vue?vue&type=template&id=5f14bc02&scoped=true&ts=true"
import script from "./management.vue?vue&type=script&lang=ts"
export * from "./management.vue?vue&type=script&lang=ts"

import "./management.vue?vue&type=style&index=0&id=5f14bc02&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f14bc02"]])

export default __exports__